import { render, staticRenderFns } from "./LKBannersHeader.vue?vue&type=template&id=65685736&"
import script from "./LKBannersHeader.vue?vue&type=script&lang=js&"
export * from "./LKBannersHeader.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/transitions/transition-fade.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./LKBannersHeader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
